import React, { PropTypes, Component } from 'react';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import SingleCancellation from './singleCancellation.jsx';
import HelperLink from '../../product/helper-link';
import { FontIcon } from 'material-ui';
import R, { propOr, isEmpty, complement, prop, pluck, flatten, either, isNil, merge } from 'ramda';
import ExpandableTextBlock from '../../../../tc-ui/expandable-text-block';
const notNil = complement(isNil);
const existsAndNotEmpty = complement(either(isEmpty, isNil));
class CancellationPolicy extends Component {
  render() {
    const {
      cancellationInfo,
      editCancellation,
      addCancellation,
      supplierEditable,
      deletePolicy,
      openAddEditContractDialog,
      existingSeasons = [],
      label = '',
      classes = {},
      inMaster,
    } = this.props;
    if (!(cancellationInfo && Object.keys(cancellationInfo).length)) {
      return (<div>
        <div id="cancellationPolicy" style={{ marginBottom: '12px' }}>
          <HelperLink
            value="cancellation"
            justLabel={inMaster}
          >
            {label}
          </HelperLink>
        </div>
        <AddItemCard
          onClick={addCancellation}
          text={`Add ${label.toLowerCase()}`}
          editable={supplierEditable}
        />
      </div>);
    }
    const cancellations = propOr([], 'cancellations', cancellationInfo);
    const additionalRules = cancellationInfo.additionalRules || [];
    const varyBySeason = cancellations
      && cancellations.length
      && (
        cancellations.length > 1
        || R.path([0, 'dateRanges', 'length'], cancellations) > 1
      );
    const basicRuleExist = notNil(cancellationInfo.cancelNum) && notNil(cancellationInfo.cancelHoursDays);
    // if (!(cancellations.length || basicRuleExist)) return <div/>;
    return (
      <div>
        <div id="cancellationPolicy">
          <HelperLink
            showSync={existsAndNotEmpty(cancellations)}
            value="cancellation"
            openEditDialog={editCancellation}
            justLabel={inMaster}
          >
            <b>{label}</b>
          </HelperLink>
        </div>
        <MouseOverEditDiv
          editable={supplierEditable}
          extendPadding
          regularDiv={cancellations && cancellations.length > 1 && R.any(R.compose(R.isEmpty, R.prop('dateRanges')), existingSeasons)}
          hintOnRight={existsAndNotEmpty(cancellations)}
          actionButtons={<EditButton onEdit={editCancellation} deleteButton={Boolean(deletePolicy)} onDelete={deletePolicy} />}
        >
          <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={classes.main}>
            {
              existsAndNotEmpty(cancellations) ?
                (<div>
                  { cancellations.map((cancellation, index) => {
                    const { dateRanges } = cancellations.length > 1 ? (existingSeasons[index] || cancellation) : cancellation;
                    return (
                      <SingleCancellation
                        key={index}
                        index={index}
                        classes={classes}
                        {...merge(cancellation, { dateRanges })}
                        varyBySeason={varyBySeason}
                        existingSeasons={existingSeasons}
                        openAddEditContractDialog={openAddEditContractDialog}
                      />
                    );
                  }) }
                </div>) :
                (<div>
                  {
                    basicRuleExist ? (
                      <div>
                        Cancel at least <b><span className={classes.cancelNum}>{cancellationInfo.cancelNum}</span> <span className={classes.cancelHoursDays}>{cancellationInfo.cancelHoursDays}</span></b> prior to the date of travel to avoid any cancellation fees.
                      </div>
                    ) : <span/>
                  }
                  {
                    additionalRules && additionalRules.length ? (
                      <div>
                        <b style={{ display: 'inline-block', margin: '8px 0' }}>Additional Cancellation Rules</b>
                        {
                          additionalRules.map((rule, ruleIndex) => (
                            <div key={ruleIndex}>
                              {ruleIndex + 1}. If cancelled within <b>{rule.cancelNum}</b> <b>{rule.cancelHoursDays}</b> of the date of <b>{rule.arrivalDeparture}</b>, a fee equivalent to <b>{rule.cancelFee}</b> <b>{rule.feeDollarPercent}</b> <b>{rule.feeBase}</b> will be charged.
                            </div>
                          ))
                        }
                      </div>
                    ) : <div/>
                  }
                  <ExpandableTextBlock
                    className={classes['conditions-textblock'] ? '' : classes['conditions']}
                    style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                  >
                    {classes['conditions-textblock'] || (propOr('', 'conditions', cancellationInfo).toLowerCase() === 'na' ? '' : propOr('', 'conditions', cancellationInfo))}
                  </ExpandableTextBlock>
                </div>)
            }
          </div>
        </MouseOverEditDiv>
      </div>
    );
  }
}

CancellationPolicy.propTypes = {
  cancellationInfo: PropTypes.object,
  editCancellation: PropTypes.func,
  addCancellation: PropTypes.func,
  deletePolicy: PropTypes.func,
  supplierEditable: PropTypes.bool,
  contractingPeriod: PropTypes.object,
  openAddEditContractDialog: PropTypes.func,
  existingSeasons: PropTypes.array,
  label: PropTypes.string,
  classes: PropTypes.object,
  inMaster: PropTypes.bool,
};

export default CancellationPolicy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/cancellation.jsx